export default "__VITE_ASSET__251249c7__"